import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-callcenter',
  templateUrl: './callcenter.component.html',
  styleUrls: ['./callcenter.component.scss']
})
export class CallcenterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
